<div class="w-100">
  <h2 class="mb-5">Skills</h2>

  <div class="subheading mb-3">Programming Languages &amp; Tools</div>
  <ul class="list-inline dev-icons">
    <li class="list-inline-item" *ngFor="let Skill of SkillIcons">
      <i class="{{Skill.icon}}" [matTooltip]="Skill.toolTip"></i>
    </li>
  </ul>
</div>
